import {Box, Flex, Image, keyframes, Text} from '@chakra-ui/react'
import partTwoImage from '@assets/images/learn/image-part-two.png'

import {useSelector} from 'react-redux'
import {styleByTextTag} from '@utils'
import {Fragment} from 'react'

const slideUp = keyframes`
from { transform: translateY(20px); opacity: 0; }
to { transform: translateY(0); opacity: 1; }
`

const TopContent = () => {
  const {currentContent, introductionData} = useSelector(
    (state: any) => state.learnPartThree,
  )
  const animation = `${slideUp} 0.5s ease-out`

  return (
    <Flex height={'200px'} direction="column">
      <Flex>
        <Image src={partTwoImage} alt="part-two" />
        <Box
          padding={'24px'}
          border={'1px solid #D0D5DD'}
          borderRadius={'12px'}
          borderBottomLeftRadius={'none'}
          height={'fit-content'}
          animation={animation}
          fontSize={'16px'}>
          {currentContent?.introduction &&
            currentContent?.type !== 'P3_GET_IDEA' &&
            styleByTextTag(currentContent?.introduction)}
          {currentContent?.type !== 'P3_GET_IDEA' && (
            <Text
              fontSize={'18px'}
              fontWeight={600}
              mt={'8px'}
              color={'#475467'}>
              {currentContent?.data?.lesson_topic}
            </Text>
          )}
          {currentContent?.type === 'P3_GET_IDEA' && (
            <>
              <Text fontSize={'16px'}>{introductionData?.open_text}</Text>
              <Flex gap={'8px'} my={'4px'} alignItems={'center'}>
                {introductionData?.blocks?.map((item: any, index: number) => (
                  <Fragment key={index}>
                    <Text
                      fontWeight={600}
                      border={'1px solid #E4E7EC'}
                      borderRadius={'100px'}
                      padding={'4px 12px'}
                      bg={'#F9FAFB'}>
                      {item}
                    </Text>
                    {index < introductionData?.blocks?.length - 1 && (
                      <Text fontSize={'16px'}>+</Text>
                    )}
                  </Fragment>
                ))}
              </Flex>
              <Text fontSize={'16px'}>{introductionData?.close_text}</Text>
              {typeof introductionData === 'string' && (
                <Text fontSize={'16px'}>{introductionData}</Text>
              )}
            </>
          )}
        </Box>
      </Flex>
    </Flex>
  )
}

export default TopContent
